/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Exchange Code Body
 * @export
 * @interface ExchangeCodeForTokensRequest
 */
export interface ExchangeCodeForTokensRequest {
    /**
     * OAuth Code
     * @type {string}
     * @memberof ExchangeCodeForTokensRequest
     */
    code: string;
}

/**
 * Check if a given object implements the ExchangeCodeForTokensRequest interface.
 */
export function instanceOfExchangeCodeForTokensRequest(value: object): value is ExchangeCodeForTokensRequest {
    if (!('code' in value) || value['code'] === undefined) return false;
    return true;
}

export function ExchangeCodeForTokensRequestFromJSON(json: any): ExchangeCodeForTokensRequest {
    return ExchangeCodeForTokensRequestFromJSONTyped(json, false);
}

export function ExchangeCodeForTokensRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExchangeCodeForTokensRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
    };
}

export function ExchangeCodeForTokensRequestToJSON(value?: ExchangeCodeForTokensRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'code': value['code'],
    };
}

